import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { toast } from 'sonner';
interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ChangePasswordModal({
  isOpen,
  onClose
}: ChangePasswordModalProps) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error('Passwords do not match');
      return;
    }
    if (next.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }
    toast.success('Password changed successfully');
    setCurrent('');
    setNext('');
    setConfirm('');
    onClose();
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" data-id="element-609" data-mp="2pxq48xck9hz6">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl overflow-hidden" data-id="element-610" data-mp="2uvhuzo1gyy1s">
        <div className="flex items-center justify-between p-5 border-b border-gray-200" data-id="element-611" data-mp="1wgoaoav6hxe4">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-612" data-mp="1riwe33jl9n3l">Change Password</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100" aria-label="Close" data-id="element-613" data-mp="26fnftjgqjawd">
            <XIcon className="w-5 h-5" data-id="element-614" data-mp="2ffafo0ttg8nb" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4" data-id="element-615" data-mp="2fdh88jbdpke9">
          <div data-id="element-616" data-mp="2af5x859cl3ug">
            <label className="text-sm font-medium text-gray-700" data-id="element-617" data-mp="2afflnoeqv2y1">
              Current Password
            </label>
            <input type="password" value={current} onChange={e => setCurrent(e.target.value)} required className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-618" data-mp="2p4brrfx8q5w0" />
          </div>
          <div data-id="element-619" data-mp="317ej8ibyf3qs">
            <label className="text-sm font-medium text-gray-700" data-id="element-620" data-mp="317wm3xt4gg7o">
              New Password
            </label>
            <input type="password" value={next} onChange={e => setNext(e.target.value)} required className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-621" data-mp="365ofyxdbucei" />
          </div>
          <div data-id="element-622" data-mp="3jx3057iz0jn5">
            <label className="text-sm font-medium text-gray-700" data-id="element-623" data-mp="3jxmigpcj9a1p">
              Confirm New Password
            </label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-624" data-mp="3oys7ac32od5y" />
          </div>
          <div className="flex gap-3 pt-2" data-id="element-625" data-mp="24gm0fcxmyxlb">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50" data-id="element-626" data-mp="24hdx6r2yz1d6">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2.5 bg-[#1E2B55] text-white font-medium rounded-lg hover:bg-[#162041]" data-id="element-627" data-mp="cswd74o98pmj">
              Update Password
            </button>
          </div>
        </form>
      </div>
    </div>;
}